import { Box, DialogTitle } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { ReactNode } from 'react';

type CockpitDialogTitleProps = {
  children: ReactNode;
  onClose?: () => void;
  closeLabel?: string;
  closeTestId?: string;
  disabled?: boolean;
  sx?: SxProps<Theme>;
  titleSx?: SxProps<Theme>;
};

/** Shared non-destructive close affordance for Cockpit dialogs. */
export function CockpitDialogTitle({
  children,
  sx,
  titleSx
}: CockpitDialogTitleProps) {
  return (
    <DialogTitle
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        fontFamily: 'var(--cockpit-font-heading)',
        ...sx
      }}
    >
      <Box
        sx={{
          minWidth: 0,
          font: 'inherit',
          ...titleSx
        }}
      >
        {children}
      </Box>
    </DialogTitle>
  );
}
